/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ExportLogEntryStatus } from '../enums/export-log-entry-status.enum';

export class ClearanceCaseCustomsDocumentChanges {
  public id: string = undefined;
  public status: ExportLogEntryStatus;
}
